import request from '../utils/request';

/**
 * 获取店铺列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页数量
 * @returns {Promise}
 */
export const getStores = (params) => {
  return request.get('/stores', { params });
};

/**
 * 获取店铺详情
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const getStoreById = (id) => {
  return request.get(`/stores/${id}`);
};

/**
 * 创建店铺
 * @param {Object} data - 店铺信息
 * @param {string} data.name - 店铺名称
 * @param {string} data.address - 店铺地址
 * @param {string} data.phone - 联系电话
 * @returns {Promise}
 */
export const createStore = (data) => {
  const newData = { ...data };
  console.log(newData)
  return request.post('/stores', newData);
};

/**
 * 更新店铺
 * @param {number} id - 店铺ID
 * @param {Object} data - 店铺信息
 * @param {string} data.name - 店铺名称
 * @param {string} data.address - 店铺地址
 * @param {string} data.phone - 联系电话
 * @returns {Promise}
 */
export const updateStore = (id, data) => {
  return request.put(`/stores/${id}`, data);
};

/**
 * 删除店铺
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const deleteStore = (id) => {
  return request.delete(`/stores/${id}`);
};

export const visibleStore = async (user_id) => {
  return await request({
    url: `/stores/visible?user_id=${user_id}`,
    method: 'get',
  })
};



/**
 * 获取店铺可见用户
 * @param {number} id - 店铺ID
 * @returns {Promise}
 */
export const visibleUser = async (id) => {
  return await request({
    url: `/stores/${id}/users`,
    method: 'get',
  })
}

export const batchSetStorePermissions = async (data) => {
  return await request({
    url: '/stores/permission',
    method: 'post',
    data: data,
  })
}

export const statisticsStore = async (ip) => {
  const targetUrl = `${ip}/store/statistics`
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  });
};


// 添加店铺健康检查API
export const checkStoreHealth = async (ip) => {
  const targetUrl = `${ip}/health`;
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  });
};

export const getEmployeeList = async (ip) => {
  const targetUrl = `${ip}/empleado/list`
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
}

export const getOrderInfo = async (ip, startDate, endDate, operador_id) => {
  console.log('getOrderInfo - 参数: ', startDate, endDate, operador_id)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/order/statistics?start_date=${startDate}&end_date=${endDate}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/order/statistics?start_date=${startDate}&end_date=${endDate}`
  }
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};

// 获取支付明细
export const getExpensesDetails = async (ip, startDate, endDate, operador_id) => {
  console.log('getExpensesDetails - 参数: ', startDate, endDate, operador_id)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/expenses/statistics?start_date=${startDate}&end_date=${endDate}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/expenses/statistics?start_date=${startDate}&end_date=${endDate}`
  }
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })

  // mock 数据
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({ "success": true, "data": { "Efectivo": 196.25, "Tarjeta": -3 } })
  //   }, 50)
  // })
};


// 获取退货明细
export const getRefund = async (ip, startDate, endDate, operador_id) => {
  console.log('geRefund - 参数: ', startDate, endDate, operador_id)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/refund?start_date=${startDate}&end_date=${endDate}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/refund?start_date=${startDate}&end_date=${endDate}`
  }
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })

  // mock 数据
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({ "success": true, "data": { "ssd": 19.25, "Tarjeta": -3, "Efectivo": -3, "Total": -6, "Total_ssd": 19.25, "Total_Tarjeta": -3, "Total_Efectivo": -3, "Total_Total": -6, "Total_Total_ssd": 19.25, "Total_Total_Tarjeta": -3, "Total_Total_Efectivo": -3 } })
  //   }, 50)
  // })
};

export const getRefundDetail = async (ip, startDate, endDate, formaDePago, operador_id) => { 
  
  console.log('geRefundDetail - 参数: ', startDate, endDate,formaDePago, operador_id)
  let targetUrl = ""
  if (operador_id) {
    targetUrl = `${ip}/refund/detail?start_date=${startDate}&end_date=${endDate}&forma_de_pago=${formaDePago}&operador_id=${operador_id}`
  } else {
    targetUrl = `${ip}/refund/detail?start_date=${startDate}&end_date=${endDate}&forma_de_pago=${formaDePago}`
  }
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};

export const getTimezone = async (ip) => {
  const targetUrl = `${ip}/timezone`
  return await request.get('/proxy', {
    params: {
      address: encodeURIComponent(targetUrl)
    }
  })
};
